import { createFormDataRequest } from "@/helpers/FormHelpers";
import { IFilters, IPaginateResponse } from "@/interfaces/Fetch";
import Note, { NoteForm } from "@/interfaces/Note";
import api from "../api";

export const personNotesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPersonNotes: build.query<IPaginateResponse<Note>, [string, IFilters]>({
      query: ([id, data]) => {
        const params = createFormDataRequest(data);
        return {
          url: `/people/${id}/notes`,
          params,
        };
      },
      providesTags: (result, _error, _arg) =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: "PersonNotes" as const,
                id,
              })),
              { type: "PersonNotes", id: "LIST" },
            ]
          : [],
    }),
    storePersonNote: build.mutation<Note, [string, NoteForm]>({
      query: ([id, body]) => ({
        url: `/people/${id}/notes`,
        method: "POST",
        body,
      }),
      invalidatesTags: (_result, _error, [userId]) => [
        { type: "PersonNotes", userId },
      ],
    }),
    deletePersonNote: build.mutation<void, [string, string]>({
      query: ([personId, noteId]) => ({
        url: `/people/${personId}/notes/${noteId}`,
        method: "DELETE",
      }),
      invalidatesTags: (_result, _error, [personId]) => [
        { type: "PersonNotes", personId, id: "LIST" },
      ],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetPersonNotesQuery,
  useStorePersonNoteMutation,
  useDeletePersonNoteMutation,
} = personNotesApi;
